import React from 'react'
import ReactDOM from 'react-dom'
import Alert from 'react-s-alert'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'

import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/scale.css'
import './assets/css/main.scss'


import Root from './containers/Root'

ReactDOM.render(
  <div>
    <Root />
    <Alert stack={{ limit: 3 }} postition="top-right" />
  </div>,
  document.getElementById('root')
)